import {createFileRoute, redirect} from '@tanstack/react-router'
import {isAuthenticated} from "../utils/auth.ts";
import SignUpForm from "../components/Auth/SignUpForm.tsx";

export const Route = createFileRoute('/signup')({
  beforeLoad: async () => {
    if(isAuthenticated()) {
      throw redirect({to: '/sessions', replace: true});
    }
  },
  component: SignUpForm
});
